
import React from 'react'
import SearchResults from './SearchResults'
import SearchHero from './SearchHero'

const SearchPage = () => {
  return (
    <div>
        <SearchHero/>
      <SearchResults/>
    </div>
  )
}

export default SearchPage
